/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IGeoPositionable {
        geoElement: IGeoElement;
        href: string;
        physicalLocation: string;
    }
    
    export interface INodeLocation {
        lat: number;
        lng: number;
        address: string;
    }
    
    export interface IGeoElement {
        id?: number;
        auto: boolean;
        autoLat: number;
        autoLong: number;
        manualLat: number;
        manualLong: number;
    }
    
    export class GeoElement implements IGeoElement {
        public id: number;
        public auto: boolean;
        public autoLat: number;
        public autoLong: number;
        public manualLat: number;
        public manualLong: number;

        public static samePosition(geo1: IGeoElement, geo2: IGeoElement): boolean {
            if (geo1 === undefined || geo2 === undefined)
                return false;
            if (geo1.auto && geo2.auto)
                return (Common.Utils.round(geo1.autoLat, 4) === Common.Utils.round(geo2.autoLat, 4) &&
                    Common.Utils.round(geo1.autoLong, 4) === Common.Utils.round(geo2.autoLong, 4)) ? true : false;
            else if (!geo1.auto && !geo2.auto)
                return (Common.Utils.round(geo1.manualLat, 4) === Common.Utils.round(geo2.manualLat, 4) &&
                    Common.Utils.round(geo1.manualLong, 4) === Common.Utils.round(geo2.manualLong, 4)) ? true : false;
            return false;
        }

        public static hasGeoPosition(geoPositionable: Models.IGeoPositionable): boolean {
            return (geoPositionable.geoElement.auto &&
                    typeof geoPositionable.geoElement.autoLat === "number" && typeof geoPositionable.geoElement.autoLong === "number") ||
                   (!geoPositionable.geoElement.auto &&
                    typeof geoPositionable.geoElement.manualLat === "number" && typeof geoPositionable.geoElement.manualLong === "number");
        };

        /**
         * TopologyElement's empty constructor for automatic conversion from REST data.
         */
        constructor() {
            this.id = undefined;
            this.auto = undefined;
            this.autoLat = undefined;
            this.autoLong = undefined;
            this.manualLat = undefined;
            this.manualLong = undefined;
        }
    }
}